document.addEventListener('DOMContentLoaded', () => {
	syncWishlistCount();
	initGpoSubmitSync();
	initGloboCheckboxMinMax();
});

function syncWishlistCount() {
	const BADGE_SELECTOR = '.MuiBadge-badge.MuiBadge-anchorOriginTopLeftRectangle.MuiBadge-colorSecondary';
	const CUSTOM_COUNT_SELECTOR = '.wishlist-count';

	let badgeNode = null;
	let badgeTextObserver = null;

	const extractCount = (node) => {
		const numeric = (node?.textContent || '').replace(/[^\d]/g, '');
		const parsed = parseInt(numeric, 10);
		return Number.isFinite(parsed) ? parsed : 0;
	};

	const updateCustomCount = (count) => {
		document.querySelectorAll(CUSTOM_COUNT_SELECTOR).forEach((el) => {
			el.textContent = count;
			el.classList.toggle('hidden', count <= 0);
		});
	};

	const watchBadgeText = (node) => {
		if (!node || node === badgeNode) return;

		badgeNode = node;
		if (badgeTextObserver) badgeTextObserver.disconnect();

		const sync = () => updateCustomCount(extractCount(node));
		sync();

		badgeTextObserver = new MutationObserver(sync);
		badgeTextObserver.observe(node, { childList: true, characterData: true, subtree: true });
	};

	const monitorForBadge = () => {
		const immediateBadge = document.querySelector(BADGE_SELECTOR);
		if (immediateBadge) watchBadgeText(immediateBadge);

		const bodyObserver = new MutationObserver(() => {
			const candidate = document.querySelector(BADGE_SELECTOR);
			if (candidate && candidate !== badgeNode) {
				watchBadgeText(candidate);
			}
		});

		bodyObserver.observe(document.body, { childList: true, subtree: true });
	};

	monitorForBadge();
}

function initGloboCheckboxMinMax() {
	const GLOBO_CHECKBOX_SELECTOR = '.gpo-checkbox input[type="checkbox"][data-min-selection], .gpo-checkbox input[type="checkbox"][data-max-selection]';
	let initializedGroups = new Set();
	
	const getCheckboxGroup = (checkbox) => {
		const fieldName = checkbox.getAttribute('data-field-name');
		if (!fieldName) return [];
		
		return Array.from(
			document.querySelectorAll(`input[type="checkbox"][data-field-name="${fieldName}"]`)
		);
	};
	
	const getMinMax = (checkbox) => {
		const min = parseInt(checkbox.getAttribute('data-min-selection'), 10) || 0;
		const max = parseInt(checkbox.getAttribute('data-max-selection'), 10) || Infinity;
		return { min, max };
	};
	
	const countChecked = (checkboxes) => {
		return checkboxes.filter(cb => cb.checked).length;
	};
	
	const updateGroupState = (group) => {
		if (!group.length) return;
		
		const { min, max } = getMinMax(group[0]);
		const checkedCount = countChecked(group);
		
		group.forEach(checkbox => {
			if (!checkbox.checked) {
				// Disable unchecked boxes if we're at maximum
				checkbox.disabled = checkedCount >= max;
			} else {
				// Keep checked boxes enabled
				checkbox.disabled = false;
			}
		});
		
		// Show custom message when at maximum
		updateMaxMessage(group[0], checkedCount, max);
	};
	
	const updateMaxMessage = (checkbox, checkedCount, max) => {
		const gpoElement = checkbox.closest('.gpo-element');
		if (!gpoElement) return;
		
		let messagesDiv = gpoElement.querySelector('.messages');
		if (!messagesDiv) return; // Only work with Globo's existing messages div
		
		if (checkedCount >= max) {
			// Replace Globo's error message with our max message
			messagesDiv.innerHTML = `<p class="help-block error">Maximum ${max} option${max > 1 ? 's' : ''} selected</p>`;
		} else {
			// Clear the max message when below maximum
			// Let Globo handle showing minimum validation on form submit
			const currentMsg = messagesDiv.querySelector('.help-block');
			if (currentMsg && currentMsg.textContent.includes('Maximum')) {
				messagesDiv.innerHTML = '';
			}
		}
	};
	
	const handleCheckboxClick = (evt) => {
		const checkbox = evt.target;
		if (!checkbox.matches('input[type="checkbox"][data-field-name]')) return;
		
		const group = getCheckboxGroup(checkbox);
		const { min, max } = getMinMax(checkbox);
		const checkedCount = countChecked(group);
		
		// Prevent unchecking if it would go below minimum
		// checkbox.checked is FALSE means user JUST UNCHECKED it
		if (!checkbox.checked && checkedCount < min) {
			evt.preventDefault();
			checkbox.checked = true;
			return;
		}
		
		// Prevent checking if it would exceed maximum
		// checkbox.checked is TRUE means user JUST CHECKED it
		if (checkbox.checked && checkedCount > max) {
			evt.preventDefault();
			checkbox.checked = false;
			return;
		}
	};
	
	const handleCheckboxChange = (evt) => {
		const checkbox = evt.target;
		if (!checkbox.matches('input[type="checkbox"][data-field-name]')) return;
		
		const group = getCheckboxGroup(checkbox);
		updateGroupState(group);
	};
	
	const initializeAllGroups = () => {
		const allCheckboxes = document.querySelectorAll(GLOBO_CHECKBOX_SELECTOR);
		const processedGroups = new Set();
		
		allCheckboxes.forEach(checkbox => {
			const fieldName = checkbox.getAttribute('data-field-name');
			if (!fieldName || processedGroups.has(fieldName)) return;
			
			processedGroups.add(fieldName);
			
			// Only mark as initialized, don't call updateGroupState
			// This prevents auto-checking on page load
			// The change event handler will update state when user interacts
			if (!initializedGroups.has(fieldName)) {
				initializedGroups.add(fieldName);
			}
		});
	};
	
	// Listen for clicks to prevent unchecking below minimum
	document.addEventListener('click', handleCheckboxClick, true);
	
	// Listen for changes to update group state
	document.addEventListener('change', handleCheckboxChange);
	
	// Monitor for Globo injecting checkboxes after page load
	const monitorForGloboCheckboxes = () => {
		// Initialize immediately if checkboxes are present
		initializeAllGroups();
		
		// Watch for new checkboxes being added (with a delay to avoid triggering on every mutation)
		let debounceTimer = null;
		const bodyObserver = new MutationObserver(() => {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => {
				// Only reinitialize if we find new checkbox groups
				const allCheckboxes = document.querySelectorAll(GLOBO_CHECKBOX_SELECTOR);
				allCheckboxes.forEach(checkbox => {
					const fieldName = checkbox.getAttribute('data-field-name');
					if (fieldName && !initializedGroups.has(fieldName)) {
						initializeAllGroups();
					}
				});
			}, 100);
		});
		
		bodyObserver.observe(document.body, { childList: true, subtree: true });
	};
	
	monitorForGloboCheckboxes();
}

function initGpoSubmitSync() {
	const SUBMIT_SELECTOR = '.product-form__submit';

	const isGloboField = (el) => !!el?.closest('.gpo-option, .gpo-field, .globo-options');

	const enableIfValid = () => {
		const btn = document.querySelector(SUBMIT_SELECTOR);
		if (!btn) return;

		const hasInvalidRequired = !!document.querySelector('.gpo-field.gpo-required :invalid');
		if (!hasInvalidRequired) {
			btn.disabled = false;
			btn.classList.remove('disabled');
		}
	};

	document.addEventListener('change', (evt) => {
		if (!isGloboField(evt.target)) return;
		enableIfValid();
	});

	const form = document.querySelector('.product-form');
	if (form) {
		const observer = new MutationObserver(() => enableIfValid());
		observer.observe(form, { childList: true, subtree: true });
	}

	enableIfValid();
}